import React from "react";
import { cn } from "../../../../../lib/utils";

interface UserInitialIconProps {
  name?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const size_classes = {
  sm: "w-6 h-6 text-xs",
  md: "w-8 h-8 text-sm",
  lg: "w-10 h-10 text-base",
};

/**
 * User icon showing the first initial of their first name
 */
export function UserInitialIcon({
  name = "User",
  size = "md",
  className,
}: UserInitialIconProps) {
  const firstName = name.trim().split(/\s+/)[0] ?? name;
  const initial = firstName.charAt(0).toUpperCase() || "?";

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full text-white font-medium",
        size_classes[size],
        className
      )}
      style={{ backgroundColor: "#0b1756" }}
      aria-label={`${name}'s avatar`}
    >
      {initial}
    </div>
  );
}

export default UserInitialIcon;
